// extracted by mini-css-extract-plugin
export default {"container":"CompletedGoalGrid_container__QIbZy"};